<script lang="ts">
	import PacketNetSOPContent from './sop.svx';
</script>

<div class="prose prose-blue dark:prose-invert max-w-none">
	<PacketNetSOPContent />
</div>
